module.exports = __webpack_public_path__ + "img/moscow_snap.b9c60cac.png";